import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import { useSelector } from 'react-redux';

const ApplicationForm = () => {
  const authState = useSelector(state => state.authReducer);
  const [submitStatus, setSubmitStatus] = useState('');
  const [isError, setIsError] = useState(false);
  const navigate = useNavigate();
  const [fetchData, { loading }] = useFetch();

  const [formData, setFormData] = useState({
    propertyTitle: '',
    propertyCode: '',
    propertyType: '',
    description: '',
    price: '',
    size: '',
    location: '',
    contactEmail: '',
    contactPhone: '',
    website: '',
    isApproved: false,
    isActive: false,
    tags: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const config = {
      url: '/propertylisting',
      method: 'post',
      data: formData,
      headers: { Authorization: authState.token }
    };

    try {
      const response = await fetchData(config);

      if (response && response.status) {
        setSubmitStatus('Thank you! Your property has been submitted and is under review.');
        setIsError(false);
        setFormData({
          propertyTitle: '',
          propertyCode: '',
          propertyType: '',
          description: '',
          price: '',
          size: '',
          location: '',
          contactEmail: '',
          contactPhone: '',
          website: '',
          isApproved: false,
          isActive: false,
          tags: '',
        });
      } else {
        setSubmitStatus('Sorry, we encountered an issue while submitting your property.');
        setIsError(true);
      }
    } catch (error) {
      console.error('Submit error:', error);
      setSubmitStatus('Something went wrong. Please try again later.');
      setIsError(true);
    }
  };

  return (
    <section id="property" className="py-20 px-4 sm:px-6 md:px-20 bg-blue-50 text-center">
      <h2 className="text-3xl font-bold mb-6 text-green-700">List Your Property</h2>
      <p className="text-lg mb-8 max-w-2xl mx-auto text-gray-700">
        Reach thousands of potential buyers or renters. Start by listing your property today.
      </p>
      <form onSubmit={handleSubmit} className="max-w-2xl mx-auto bg-white p-6 rounded-lg shadow-md text-left">
        <select name="propertyType" value={formData.propertyType} onChange={handleChange} className="h-10 mb-4 w-full p-2 border rounded" required>
          <option value="">Select Property Type</option>
          <option value="Apartment">Apartment</option>
          <option value="Villa">Villa</option>
          <option value="Plot">Plot</option>
          <option value="Commercial">Commercial</option>
        </select>
        <input name="propertyTitle" value={formData.propertyTitle} onChange={handleChange} placeholder="Property Title" className="mb-4 w-full p-2 border rounded" required />
        <input name="propertyCode" value={formData.propertyCode} onChange={handleChange} placeholder="Property Code" className="mb-4 w-full p-2 border rounded" required />
        <textarea name="description" value={formData.description} onChange={handleChange} placeholder="Property Description" style={{height: "200px"}} className="mb-4 w-full p-2 border rounded" required />
        <input name="price" value={formData.price} onChange={handleChange} placeholder="Price (in ₹)" className="mb-4 w-full p-2 border rounded" required />
        <input name="size" value={formData.size} onChange={handleChange} placeholder="Size (in sqft)" className="mb-4 w-full p-2 border rounded" required />
        <input name="location" value={formData.location} onChange={handleChange} placeholder="Location (City/Area)" className="mb-4 w-full p-2 border rounded" required />
        <input name="contactEmail" value={formData.contactEmail} onChange={handleChange} placeholder="Contact Email" type="email" className="mb-4 w-full p-2 border rounded" required />
        <input name="contactPhone" value={formData.contactPhone} onChange={handleChange} placeholder="Contact Phone" className="mb-4 w-full p-2 border rounded" />
        <input name="website" value={formData.website} onChange={handleChange} placeholder="Website (optional)" className="mb-4 w-full p-2 border rounded" />
        <input name="tags" value={formData.tags} onChange={handleChange} placeholder="Keywords (e.g. sea-facing, gated community)" className="mb-4 w-full p-2 border rounded" />
        <button type="submit" className="w-full bg-green-600 text-white p-2 rounded hover:bg-green-700 transition">
          Submit Property
        </button>
        {submitStatus && (
          <p className={`mt-4 ${isError ? 'text-red-600' : 'text-green-600'}`}>{submitStatus}</p>
        )}
      </form>
    </section>
  );
};

export default ApplicationForm;
